"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidTimeValue = exports.isValidTimeValue = exports.getDisabledSeconds = exports.getDisabledMinutes = exports.getDisabledHours = exports.genShowHourMinuteSecond = exports.getHourMinuteSecond = void 0;
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
var SEQUENCE_24 = Array(24)
    .fill(0)
    .map(function (_, i) { return i; });
var SEQUENCE_60 = Array(60)
    .fill(0)
    .map(function (_, i) { return i; });
var startOfDay = moment_1.default().startOf("day");
var endOfDay = moment_1.default().endOf("day");
function getHourMinuteSecond(time) {
    return {
        hour: time.hour(),
        minute: time.minute(),
        second: time.second(),
    };
}
exports.getHourMinuteSecond = getHourMinuteSecond;
/**
 * 解析 format
 * @param format
 */
function genShowHourMinuteSecond(format) {
    // Ref: http://momentjs.com/docs/#/parsing/string-format/
    return {
        showHour: format.indexOf("H") > -1 ||
            format.indexOf("h") > -1 ||
            format.indexOf("k") > -1,
        showMinute: format.indexOf("m") > -1,
        showSecond: format.indexOf("s") > -1,
    };
}
exports.genShowHourMinuteSecond = genShowHourMinuteSecond;
/**
 * 校验 range
 */
function isValidRange(range) {
    return (Array.isArray(range) &&
        (moment_1.default.isMoment(range[0]) || moment_1.default.isMoment(range[1])));
}
/**
 * 获取 disabled 部分
 */
function getDisabledHours(_a) {
    var range = _a.range, _b = _a.disabledHours, disabledHours = _b === void 0 ? function () { return []; } : _b, _c = _a.hourStep, hourStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_1 = getHourMinuteSecond(range[0] || startOfDay);
        var max_1 = getHourMinuteSecond(range[1] || endOfDay);
        return tslib_1.__spread(disabledHours(), SEQUENCE_24.filter(function (i) { return i < min_1.hour || i > max_1.hour || i % hourStep !== 0; }));
    }
    return tslib_1.__spread(disabledHours(), SEQUENCE_24.filter(function (i) { return i % hourStep !== 0; }));
}
exports.getDisabledHours = getDisabledHours;
function getDisabledMinutes(hour, _a) {
    var range = _a.range, _b = _a.disabledMinutes, disabledMinutes = _b === void 0 ? function () { return []; } : _b, _c = _a.minuteStep, minuteStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_2 = getHourMinuteSecond(range[0] || startOfDay);
        var max_2 = getHourMinuteSecond(range[1] || endOfDay);
        return tslib_1.__spread(disabledMinutes(hour), SEQUENCE_60.filter(function (i) {
            return (hour === min_2.hour && i < min_2.minute) ||
                (hour === max_2.hour && i > max_2.minute) ||
                i % minuteStep !== 0;
        }));
    }
    return tslib_1.__spread(disabledMinutes(hour), SEQUENCE_60.filter(function (i) { return i % minuteStep !== 0; }));
}
exports.getDisabledMinutes = getDisabledMinutes;
function getDisabledSeconds(hour, minute, _a) {
    var range = _a.range, _b = _a.disabledSeconds, disabledSeconds = _b === void 0 ? function () { return []; } : _b, _c = _a.secondStep, secondStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_3 = getHourMinuteSecond(range[0] || startOfDay);
        var max_3 = getHourMinuteSecond(range[1] || endOfDay);
        return tslib_1.__spread(disabledSeconds(hour, minute), SEQUENCE_60.filter(function (i) {
            return (hour === min_3.hour && minute === min_3.minute && i < min_3.second) ||
                (hour === max_3.hour && minute === max_3.minute && i > max_3.second) ||
                i % secondStep !== 0;
        }));
    }
    return tslib_1.__spread(disabledSeconds(hour, minute), SEQUENCE_60.filter(function (i) { return i % secondStep !== 0; }));
}
exports.getDisabledSeconds = getDisabledSeconds;
/**
 * 在当前配置下是否为可选值
 */
function isValidTimeValue(value, _a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.format, format = _b === void 0 ? "HH:mm:ss" : _b, _c = _a.hourStep, hourStep = _c === void 0 ? 1 : _c, _d = _a.minuteStep, minuteStep = _d === void 0 ? 1 : _d, _e = _a.secondStep, secondStep = _e === void 0 ? 1 : _e, props = tslib_1.__rest(_a, ["format", "hourStep", "minuteStep", "secondStep"]);
    var _f = getHourMinuteSecond(value), hour = _f.hour, minute = _f.minute, second = _f.second;
    var _g = genShowHourMinuteSecond(format), showHour = _g.showHour, showMinute = _g.showMinute, showSecond = _g.showSecond;
    // 范围校验
    if ((showHour && getDisabledHours(props).includes(hour)) ||
        (showMinute && getDisabledMinutes(hour, props).includes(minute)) ||
        (showSecond && getDisabledSeconds(hour, minute, props).includes(second))) {
        return false;
    }
    // 步长校验
    if ((showHour && hour % hourStep) ||
        (showMinute && minute % minuteStep) ||
        (showSecond && second % secondStep)) {
        return false;
    }
    return true;
}
exports.isValidTimeValue = isValidTimeValue;
/**
 * 获取自动调整后的合法值
 */
function getValidTimeValue(_value, rangeOptions, format) {
    if (rangeOptions === void 0) { rangeOptions = {}; }
    if (format === void 0) { format = "HH:mm:ss"; }
    var value = moment_1.default.isMoment(_value) ? _value.clone() : _value;
    var _a = genShowHourMinuteSecond(format), showHour = _a.showHour, showMinute = _a.showMinute, showSecond = _a.showSecond;
    var _b = getHourMinuteSecond(value || moment_1.default(0, "HH")), hour = _b.hour, minute = _b.minute, second = _b.second;
    var _c = rangeOptions.hourStep, hourStep = _c === void 0 ? 1 : _c, _d = rangeOptions.minuteStep, minuteStep = _d === void 0 ? 1 : _d, _e = rangeOptions.secondStep, secondStep = _e === void 0 ? 1 : _e;
    var disabledHours = getDisabledHours(rangeOptions);
    if (showHour && (disabledHours.includes(hour) || hour % hourStep !== 0)) {
        hour = SEQUENCE_24.find(function (i) { return !disabledHours.includes(i); });
    }
    var disabledMinutes = getDisabledMinutes(hour, rangeOptions);
    if (showMinute &&
        (disabledMinutes.includes(minute) || minute % minuteStep !== 0)) {
        minute = SEQUENCE_60.find(function (i) { return !disabledMinutes.includes(i); });
    }
    var disabledSeconds = getDisabledSeconds(hour, minute, rangeOptions);
    if (showSecond &&
        (disabledSeconds.includes(second) || second % secondStep !== 0)) {
        second = SEQUENCE_60.find(function (i) { return !disabledSeconds.includes(i); });
    }
    return (value || moment_1.default()).set({ hour: hour, minute: minute, second: second });
}
exports.getValidTimeValue = getValidTimeValue;
//# sourceMappingURL=util.js.map